import ArrowBack from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { Header } from 'components/Header';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

type SecondaryPageProps = {
  onBack: () => void;
  children: JSX.Element;
};

const SecondaryPage = observer(({ onBack, children }: SecondaryPageProps) => {
  useEffect(() => {
    const handleKey = (evt: KeyboardEvent) => {
      if (evt.key === 'Escape') onBack();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onBack]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Header />
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
        }}
      >
        <div aria-label="sidebar" style={{ width: 150, marginRight: 50 }}>
          <Button sx={{ margin: '30px' }} onClick={() => onBack()} variant="text" startIcon={<ArrowBack />}>
            Back
          </Button>
        </div>
        <div
          aria-label="main"
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
});

export { SecondaryPage };
